export default __webpack_public_path__ + "static/media/who-we-are-Header-2k.f5d165e5.jpg";